import { render, staticRenderFns } from "./TipOff.vue?vue&type=template&id=a56beb7c&scoped=true"
import script from "./TipOff.vue?vue&type=script&lang=js"
export * from "./TipOff.vue?vue&type=script&lang=js"
import style0 from "./TipOff.vue?vue&type=style&index=0&id=a56beb7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56beb7c",
  null
  
)

export default component.exports